import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../components/LanguageContext';
import './AboutUs.css';
import image1 from '../Images/OurVision.png';
import image2 from '../Images/OurMission.png';
import image3 from '../Images/OurAdvantages.png';
import logo from '../Images/Icon.jpeg';

const AboutUs = () => {
  const { language } = useLanguage();

  const content = {
    en: {
      tag: 'About Us',
      title: 'Excellence in Every Detail',
      companyName: 'Sparkles Laundry',
      description: 'We specialize in comprehensive cleaning solutions for facilities, palaces, and homes. Our qualified team uses cutting-edge technology to deliver exceptional results at competitive prices.',
      cards: [
        {
          title: 'Our Vision',
          text: 'To be the first choice in cleaning services through complete customer satisfaction and exceptional quality.',
          image: image1
        },
        {
          title: 'Our Mission',
          text: 'Delivering world-class cleaning services that exceed the highest global quality standards.',
          image: image2
        },
        {
          title: 'Why Choose Us',
          text: 'Fast execution by skilled teams, competitive pricing, and premium quality using the latest equipment.',
          image: image3
        }
      ]
    },
    ar: {
      tag: 'من نحن',
      title: 'التميز في كل التفاصيل',
      companyName: 'مغاسل بريق الأساس',
      description: 'نختص بتقديم حلول تنظيف شاملة للمنشآت والقصور والمنازل. فريقنا المؤهل يستخدم أحدث التقنيات لتقديم نتائج استثنائية بأسعار تنافسية.',
      cards: [
        {
          title: 'رؤيتنا',
          text: 'أن نكون الخيار الأول في خدمات التنظيف من خلال رضا العملاء الكامل والجودة الاستثنائية.',
          image: image1
        },
        {
          title: 'مهمتنا',
          text: 'تقديم خدمات تنظيف عالمية المستوى تتجاوز أعلى معايير الجودة العالمية.',
          image: image2
        },
        {
          title: 'لماذا نحن',
          text: 'تنفيذ سريع بفرق ماهرة، أسعار تنافسية، وجودة فاخرة باستخدام أحدث المعدات.',
          image: image3
        }
      ]
    }
  };

  const { tag, title, companyName, description, cards } = content[language];

  const fadeUp = {
    initial: { opacity: 0, y: 30 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.6 }
  };

  return (
    <section id="AboutUS" className={`about ${language === 'ar' ? 'rtl' : ''}`}>
      <div className="about-container">
        {/* Header */}
        <motion.div className="about-header" {...fadeUp}>
          <span className="about-tag">{tag}</span>
          <h2 className="about-title">{title}</h2>
        </motion.div>

        {/* Main Content */}
        <div className="about-grid">
          {/* Company Card */}
          <motion.div 
            className="company-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="company-logo">
              <img src={logo} alt={companyName} />
            </div>
            <h3 className="company-name">{companyName}</h3>
            <p className="company-desc">{description}</p>
          </motion.div>

          {/* Feature Cards */}
          <div className="feature-cards">
            {cards.map((card, i) => (
              <motion.div
                key={i}
                className="feature-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className="feature-icon">
                  <img src={card.image} alt={card.title} />
                </div>
                <div className="feature-content">
                  <h4>{card.title}</h4>
                  <p>{card.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
